import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-project',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.project/view.scss */
:host {
  display: block;
  min-height: 100%;
}

table {
  border-spacing: 0;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

input[type=number] {
  appearance: textfield;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-track {
  background: #f1f5f4;
}

::-webkit-scrollbar-thumb {
  border: 2px solid #f1f5f4;
  border-radius: 999px;
  background: #c7d2cf;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3a0;
}`],
})
export class PageProjectComponent implements OnInit, OnDestroy {
    public id: string = '';
    public tab: string = 'viewer';
    public loading: boolean = true;
    public saving: boolean = false;
    public dirty: boolean = false;

    public project: any = null;
    public wbsRows: any[] = [];
    public viewerRows: any[] = [];
    public viewerMeta: any = {};
    public versions: any[] = [];
    public files: any[] = [];
    public members: any[] = [];
    public activities: any[] = [];
    public source: any = null;

    public selectedVersionId: string = '';
    public selectedDivision: string = '전체실적';
    public wbsSearch: string = '';
    public fileSearch: string = '';
    public memberSearch: string = '';
    public uploadProgress: number = 0;
    public uploading: boolean = false;

    public showPublish: boolean = false;
    public publishNote: string = '';
    public showInvite: boolean = false;
    public inviteData: any = { email: '', role: 'viewer' };
    public inviting: boolean = false;
    public showSettings: boolean = false;
    public settingsData: any = {};

    public tabs: any[] = [
        { key: 'files', label: '자료함' },
        { key: 'wbs', label: 'WBS 설계' },
        { key: 'viewer', label: 'WBS 뷰어' },
        { key: 'members', label: '구성원' }
    ];

    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'viewer';
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const nextId = WizRoute.segment.id;
                const nextTab = WizRoute.segment.tab || 'viewer';
                if (nextId && nextId !== this.id) {
                    this.id = nextId;
                    this.tab = nextTab;
                    await this.load();
                } else if (nextTab !== this.tab) {
                    this.tab = nextTab;
                    await this.service.render();
                }
            }
        });

        if (!WizRoute.segment.tab) {
            this.service.href('/projects/' + this.id + '/viewer');
            return;
        }
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.id });
        if (code !== 200) {
            this.service.href('/dashboard');
            return;
        }

        this.project = data.project;
        this.wbsRows = JSON.parse(JSON.stringify(data.project.wbs || []));
        this.versions = data.versions || [];
        this.files = data.files || [];
        this.members = data.members || [];
        this.activities = data.activities || [];
        this.source = data.source || null;
        this.selectedVersionId = this.versions.length ? this.versions[0].id : '';
        this.settingsData = {
            name: this.project.name,
            client: this.project.client,
            description: this.project.description,
            start_date: this.project.start_date,
            end_date: this.project.end_date,
            status: this.project.status
        };
        this.dirty = false;
        await this.loadVersion(false);
        this.loading = false;
        await this.service.render();
    }

    public goTab(key: string) {
        this.service.href('/projects/' + this.id + '/' + key);
    }

    public canEdit() {
        return this.project && ['owner', 'editor'].includes(this.project.access_role);
    }

    public isOwner() {
        return this.project && this.project.access_role === 'owner';
    }

    public divisions(rows: any[] = this.wbsRows) {
        return Array.from(new Set(
            rows.map((row) => row.division).filter((value) => !!value)
        ));
    }

    public filteredWbsRows() {
        const query = this.wbsSearch.trim().toLowerCase();
        if (!query) return this.wbsRows;
        return this.wbsRows.filter((row) => {
            return [
                row.division, row.process, row.task, row.detail, row.owner
            ].join(' ').toLowerCase().includes(query);
        });
    }

    public addRow() {
        const rows = this.filteredWbsRows();
        const source = rows.length ? rows[rows.length - 1] : {};
        this.wbsRows.push({
            id: this.service.random(16),
            order: this.wbsRows.length + 1,
            division: source.division || this.divisions()[0] || '01. 업무구분',
            process: source.process || '',
            task: source.task || '',
            detail: '',
            division_weight: source.division_weight || 0,
            process_weight: source.process_weight || 0,
            task_weight: source.task_weight || 0,
            detail_weight: 0,
            effective_weight: 0,
            overall_weight: 0,
            owner: source.owner || '',
            start: '',
            end: '',
            plan: 0,
            progress: 0,
            status: '대기',
            note: '',
            source_sheet: '',
            source_row: 0
        });
        this.dirty = true;
        this.service.render();
    }

    public duplicateRow(row: any) {
        const clone = JSON.parse(JSON.stringify(row));
        clone.id = this.service.random(16);
        clone.order = this.wbsRows.length + 1;
        clone.detail = clone.detail + ' (복사본)';
        clone.source_sheet = '';
        clone.source_row = 0;
        this.wbsRows.push(clone);
        this.dirty = true;
        this.service.render();
    }

    public async removeRow(row: any) {
        const confirmed = await this.service.modal.show({
            title: '세부 태스크 삭제',
            message: row.detail + ' 항목을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        this.wbsRows = this.wbsRows.filter((item) => item.id !== row.id);
        this.wbsRows.forEach((item, index) => item.order = index + 1);
        this.dirty = true;
        await this.service.render();
    }

    public markDirty() {
        this.dirty = true;
    }

    public async saveWbs(showMessage: boolean = true) {
        if (!this.canEdit()) return false;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_wbs', {
            id: this.id,
            revision: this.project.revision,
            rows: JSON.stringify(this.wbsRows)
        });
        this.saving = false;
        if (code === 200) {
            this.project.revision = data.revision;
            this.project.progress = data.progress;
            this.wbsRows = data.rows || this.wbsRows;
            this.dirty = false;
            if (showMessage) await this.service.modal.success('WBS 초안을 저장했습니다.');
            await this.service.render();
            return true;
        }
        await this.service.modal.error(
            data && data.message ? data.message : 'WBS를 저장하지 못했습니다.'
        );
        await this.service.render();
        return false;
    }

    public async openPublish() {
        if (this.dirty) {
            const saved = await this.saveWbs(false);
            if (!saved) return;
        }
        this.publishNote = '';
        this.showPublish = true;
        await this.service.render();
    }

    public async publish() {
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('publish', {
            id: this.id,
            note: this.publishNote
        });
        this.saving = false;
        if (code === 200) {
            this.showPublish = false;
            await this.service.modal.success(data.label + ' 버전을 배포했습니다.');
            await this.load();
            this.goTab('viewer');
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '버전을 배포하지 못했습니다.'
        );
        await this.service.render();
    }

    public async loadVersion(render: boolean = true) {
        const { code, data } = await wiz.call('version', {
            id: this.id,
            version_id: this.selectedVersionId
        });
        if (code === 200) {
            this.viewerMeta = data || {};
            this.viewerRows = data.rows || [];
            if (!this.divisions(this.viewerRows).includes(this.selectedDivision)) {
                this.selectedDivision = '전체실적';
            }
        }
        if (render) await this.service.render();
    }

    public visibleViewerRows() {
        if (this.selectedDivision === '전체실적') return this.viewerRows;
        return this.viewerRows.filter(
            (row) => row.division === this.selectedDivision
        );
    }

    public isNewGroup(rows: any[], index: number, key: string) {
        if (index === 0) return true;
        if (key === 'process') {
            return rows[index - 1].division !== rows[index].division ||
                rows[index - 1].process !== rows[index].process;
        }
        if (key === 'task') {
            return rows[index - 1].process !== rows[index].process ||
                rows[index - 1].task !== rows[index].task;
        }
        return true;
    }

    public weightedMetric(rows: any[], key: string) {
        let weighted = 0;
        let total = 0;
        rows.forEach((row) => {
            const weight = Number(row.overall_weight || row.effective_weight || 0);
            const value = Number(row[key] || 0);
            if (weight > 0) {
                weighted += weight * value;
                total += weight;
            }
        });
        return total > 0 ? Math.round((weighted / total) * 100) / 100 : 0;
    }

    public viewerPlan() {
        if (this.source && this.viewerMeta.label === 'v1.0' && this.selectedDivision === '전체실적') {
            return this.source.summary.plan;
        }
        if (this.source && this.viewerMeta.label === 'v1.0' && this.selectedDivision !== '전체실적') {
            const item = this.source.workstreams.find((workstream) => workstream.name === this.selectedDivision);
            if (item) return item.plan;
        }
        return this.weightedMetric(this.visibleViewerRows(), 'plan');
    }

    public viewerProgress() {
        if (this.source && this.viewerMeta.label === 'v1.0' && this.selectedDivision === '전체실적') {
            return this.source.summary.progress;
        }
        if (this.source && this.viewerMeta.label === 'v1.0' && this.selectedDivision !== '전체실적') {
            const item = this.source.workstreams.find((workstream) => workstream.name === this.selectedDivision);
            if (item) return item.progress;
        }
        if (this.selectedDivision === '전체실적') return Number(this.viewerMeta.progress || 0);
        return this.weightedMetric(this.visibleViewerRows(), 'progress');
    }

    public viewerAchievement() {
        if (this.source && this.viewerMeta.label === 'v1.0' && this.selectedDivision === '전체실적') {
            return this.source.summary.achievement;
        }
        const plan = this.viewerPlan();
        if (!plan) return 0;
        return Math.round((this.viewerProgress() / plan) * 10000) / 100;
    }

    public statusLabel(status: string) {
        const labels: any = {
            completed: '완료',
            in_progress: '진행중',
            not_started: '대기',
            unknown: '미계획'
        };
        return labels[status] || status || '대기';
    }

    public statusClass(status: string) {
        const value = this.statusLabel(status);
        if (value === '완료') return 'bg-emerald-50 text-emerald-700 ring-emerald-600/15';
        if (value === '진행중') return 'bg-blue-50 text-blue-700 ring-blue-600/15';
        if (value === '예정') return 'bg-amber-50 text-amber-700 ring-amber-600/15';
        return 'bg-slate-100 text-slate-500 ring-slate-500/10';
    }

    public filteredFiles() {
        const query = this.fileSearch.trim().toLowerCase();
        if (!query) return this.files;
        return this.files.filter((file) => file.name.toLowerCase().includes(query));
    }

    public async chooseFiles(event: any) {
        const files = Array.from(event.target.files || []);
        await this.uploadFiles(files);
        event.target.value = '';
    }

    public async onDrop(event: any) {
        event.preventDefault();
        const files = await this.service.file.drop(event);
        await this.uploadFiles(files || []);
    }

    public async uploadFiles(files: any[]) {
        if (!files.length || !this.canEdit()) return;
        this.uploading = true;
        this.uploadProgress = 0;
        await this.service.render();
        const form = new FormData();
        form.append('project_id', this.id);
        files.forEach((file: any) => form.append('file[]', file));
        const response: any = await this.service.file.upload(
            wiz.url('upload'),
            form,
            async (percent: number) => {
                this.uploadProgress = Math.round(percent);
                await this.service.render();
            }
        );
        this.uploading = false;
        this.uploadProgress = 0;
        if (response && response.code === 200) {
            await this.load();
            this.tab = 'files';
        } else {
            await this.service.modal.error(
                response && response.data && response.data.message
                    ? response.data.message
                    : '파일을 업로드하지 못했습니다.'
            );
        }
        await this.service.render();
    }

    public downloadFile(file: any) {
        window.location.href = wiz.url('download') +
            '?project_id=' + encodeURIComponent(this.id) +
            '&file_id=' + encodeURIComponent(file.id);
    }

    public async removeFile(file: any) {
        const confirmed = await this.service.modal.show({
            title: '파일 제거',
            message: file.name + ' 파일을 자료함에서 제거하시겠습니까?',
            action: '제거',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call('remove_file', {
            id: this.id,
            file_id: file.id
        });
        if (code === 200) {
            await this.load();
            this.tab = 'files';
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '파일을 제거하지 못했습니다.'
        );
    }

    public fileSize(size: number) {
        if (!size) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        const index = Math.min(
            Math.floor(Math.log(size) / Math.log(1024)),
            units.length - 1
        );
        return (size / Math.pow(1024, index)).toFixed(index ? 1 : 0) + ' ' + units[index];
    }

    public fileType(name: string) {
        const extension = (name.split('.').pop() || '').toLowerCase();
        if (['xlsx', 'xls', 'csv'].includes(extension)) return { label: 'XLS', class: 'bg-emerald-50 text-emerald-700' };
        if (['pdf'].includes(extension)) return { label: 'PDF', class: 'bg-red-50 text-red-600' };
        if (['png', 'jpg', 'jpeg', 'gif', 'svg'].includes(extension)) return { label: 'IMG', class: 'bg-purple-50 text-purple-700' };
        if (['doc', 'docx', 'hwp'].includes(extension)) return { label: 'DOC', class: 'bg-blue-50 text-blue-700' };
        return { label: extension.substring(0, 3).toUpperCase() || 'FILE', class: 'bg-slate-100 text-slate-600' };
    }

    public filteredMembers() {
        const query = this.memberSearch.trim().toLowerCase();
        if (!query) return this.members;
        return this.members.filter((member) => {
            return [member.name, member.email, member.role]
                .join(' ').toLowerCase().includes(query);
        });
    }

    public openInvite() {
        this.inviteData = { email: '', role: 'viewer' };
        this.showInvite = true;
        this.service.render();
    }

    public async inviteMember() {
        if (!this.inviteData.email) {
            await this.service.modal.error('이메일을 입력해주세요.');
            return;
        }
        this.inviting = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_member', {
            id: this.id,
            data: JSON.stringify(this.inviteData)
        });
        this.inviting = false;
        if (code === 200) {
            this.showInvite = false;
            await this.load();
            this.tab = 'members';
            if (!data.mail_sent) {
                await this.service.modal.success('구성원을 추가했습니다. SMTP 연결 후 초대 메일이 발송됩니다.');
            }
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '구성원을 초대하지 못했습니다.'
        );
        await this.service.render();
    }

    public async changeMemberRole(member: any) {
        const { code, data } = await wiz.call('update_member', {
            id: this.id,
            member_id: member.id,
            role: member.role
        });
        if (code !== 200) {
            await this.service.modal.error(
                data && data.message ? data.message : '권한을 변경하지 못했습니다.'
            );
            await this.load();
            this.tab = 'members';
        }
    }

    public async removeMember(member: any) {
        const confirmed = await this.service.modal.show({
            title: '구성원 제거',
            message: member.name + '님을 프로젝트에서 제거하시겠습니까?',
            action: '제거',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call('remove_member', {
            id: this.id,
            member_id: member.id
        });
        if (code === 200) {
            await this.load();
            this.tab = 'members';
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '구성원을 제거하지 못했습니다.'
        );
    }

    public editorCount() {
        return this.members.filter(
            (member) => ['owner', 'editor'].includes(member.role)
        ).length;
    }

    public pendingCount() {
        return this.members.filter(
            (member) => member.status !== 'active'
        ).length;
    }

    public roleLabel(role: string) {
        const labels: any = { owner: '소유자', editor: '편집자', viewer: '뷰어' };
        return labels[role] || role;
    }

    public roleClass(role: string) {
        if (role === 'owner') return 'bg-[#e6f3ee] text-[#0f766e]';
        if (role === 'editor') return 'bg-blue-50 text-blue-700';
        return 'bg-slate-100 text-slate-600';
    }

    public openSettings() {
        this.settingsData = {
            name: this.project.name,
            client: this.project.client,
            description: this.project.description,
            start_date: this.project.start_date,
            end_date: this.project.end_date,
            status: this.project.status
        };
        this.showSettings = true;
        this.service.render();
    }

    public async saveSettings() {
        const { code, data } = await wiz.call('update_info', {
            id: this.id,
            data: JSON.stringify(this.settingsData)
        });
        if (code === 200) {
            this.showSettings = false;
            await this.load();
            return;
        }
        await this.service.modal.error(
            data && data.message ? data.message : '프로젝트 정보를 저장하지 못했습니다.'
        );
    }

    public activityLabel(action: string) {
        const labels: any = {
            'project.created': '프로젝트 생성',
            'project.updated': '프로젝트 정보 변경',
            'wbs.imported': 'WBS 가져오기',
            'wbs.saved': 'WBS 초안 저장',
            'wbs.published': '버전 배포',
            'file.uploaded': '파일 업로드',
            'file.downloaded': '파일 다운로드',
            'file.removed': '파일 제거',
            'member.invited': '구성원 초대',
            'member.role_changed': '권한 변경',
            'member.removed': '구성원 제거'
        };
        return labels[action] || action;
    }

    public dateText(value: any) {
        if (!value) return '-';
        return String(value).substring(0, 16).replace('T', ' ');
    }
}

export default PageProjectComponent;